module.exports = __webpack_public_path__ + "img/illustrator.63cdeac4.png";